import { createContext, useContext } from 'react';

/**
 * How a host surfaces live document data to PageLink chips rendered inside its
 * editor. Value shape:
 *
 *   {
 *     resolve(docId): { exists: boolean, title: string } | null,
 *     onOpen({ docId, scope }): void,
 *   }
 *
 * `resolve` returns null while the host's tree hasn't loaded (the chip falls
 * back to its creation-time cached title), `{ exists: false }` once the tree
 * is known and the document isn't in it (the chip renders its deleted state),
 * and `{ exists: true, title }` for a live document. `onOpen` receives the
 * scope RECONSTRUCTED FROM THE NODE's own fields (scopeType/teamId), not the
 * host's — a pasted chip opens in the scope it points at.
 *
 * Default null: an editor without a provider (task cards, collection docs)
 * renders chips inert with their cached titles.
 */
export const PageLinkContext = createContext(null);

export function usePageLink() {
  return useContext(PageLinkContext);
}
